import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { MobilePremiumCampaignComponents, MobilePremiumCampaignStores } from "../react_isomorphic/mobile/premium_campaign";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";
import { merge } from "lodash";

window.ReactComponents = merge({}, GlobalComponents, MobilePremiumCampaignComponents, HeaderComponents);
window.ReactStores = merge({}, GlobalStores, MobilePremiumCampaignStores, HeaderStores);
